<template>
  <div class="router">
    <ul class="nj-container nav-list">
      <li
        v-for="(item, index) in menuList"
        class="bgc"
        :key="index"
        :class="{ active: isActive == index }"
        @click="handleClick(index, item.path)"
      >
        {{ item.name }}
      </li>
      <li class="bgc" @click="textShow = true">关于我们</li>
    </ul>

    <el-dialog
      title="关于我们"
      :visible.sync="textShow"
      width="30vw"
      :append-to-body="true"
    >
      <span class="we">{{ txt }}</span>
    </el-dialog>
  </div>
</template>
   
<script>
export default {
  data() {
    return {
      isActive: 0,
      menuList: [
        { name: "首页", path: "/" },
        { name: "生态宜居", path: "/styj" },
        { name: "产业兴旺", path: "/cyxw" },
        { name: "乡风文明", path: "/xfwm" },
        { name: "治理有效", path: "/zlyx" },
        { name: "生活富裕", path: "/shfy" },
      ],
      textShow: false,
      txt: "",
    };
  },
  created() {
    this.getUrl(); // 可以防止刷新的时候对应菜单不高亮显示 或 第一个高亮
    this.getSYDate();
  },
  methods: {
    handleClick(index, path) {
      this.isActive = index;
      this.$router.push(path); //路由跳转
    },
    getUrl() {
      let path = this.$route.path; // 当前的路径
      let index = this.menuList.findIndex((item) => item.path === path); // 查找当前路由下的下标
      this.isActive = index;
    },
    // 获取首页统计数据
    getSYDate() {
      this.$http.get("/api/ssm/Api/index/listIndexs").then((r) => {
        this.txt = r.data.items[0].about_us;
      });
    },
  },
  watch: {
    $route: "getUrl", // 监听路由变化
  },
};
</script>
<style lang="less" scoped>
.router {
  display: flex;
  width: 46%;
  height: 6vh;
  // background-color: pink;

  ul {
    width: 100%;
    display: flex;
    text-align: center;
    font-weight: 700;

    li {
      flex: 1;
      padding: 5px;
      margin: auto 1vh;
      // border-radius: 10px;
      // background-color: #ccc;
      cursor: pointer;
    }

    li.active {
      color: #fff;
      background-color: rgb(64, 158, 255);
    }
  }
}

/deep/ .el-dialog__body {
  font-size: calc(100vw * 20 / 1920) !important;
}
</style>